<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow :close-on-content-click="false" offset-y max-height="420" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedItem" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size="13") $yzi-x-circle
        .text-xs.font-semibold Panel
        .px-1.neutral400--text |
        .text-xs.primary--text.font-medium {{ selectedItem.label }}
        v-icon.ml-1(size="16") $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-progress-circular.mr-1(v-if="isLoading" :width="2" :size="11" indeterminate)
        v-icon.mr-1(v-else size="13") $yzi-plus-circle
        .text-xs.text-none.font-semibold Panel

    .white
      .menu-header.white
        .font-semibold.text-sm.pa-4 Filter by panel
        v-text-field.text-sm.round-xl.mx-4.mb-3(v-model="searchText" @input="queryChanged" outlined placeholder="Search" dense hide-details)
        v-divider

      v-skeleton-loader.pa-4(v-if="isLoading" type="text@3")
      div(v-else)
        template(v-if="panels.length > 0")
          v-radio-group.ma-0.pa-0(v-model="checkedItem" hide-details)
            div(v-for="panel in panels" :key="panel.value")
              .d-flex.align-center.text-sm.px-4.py-3.cursor-pointer.hover-bg(@click="checkedItem = panel.value")
                v-radio.ma-0(:value="panel.value" hide-details)
                .ml-2 {{ panel.label }}
              v-divider.basic300
        template(v-else)
          .text-center.py-8.text-xs.neutral500--text No panel found

    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="checkedItem" @click="clearSelection") Clear
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="!checkedItem") Apply
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FilterPanel',
  props: {
    filter: {
      type: Object,
      default: () => ({})
    },
    panelData: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    showMenu: false,
    isLoading: true,
    searchText: '',
    panels: [],
    checkedItem: null,
    selectedItem: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    })
  },
  watch: {
    filter: {
      handler() {
        if (!this.filter.key) {
          this.clearData()
        }
      }
    },
    showMenu(value) {
      if (!value) {
        // Reset to applied selection when menu closes
        this.checkedItem = this.selectedItem?.value || null
      }
    }
  },
  mounted() {
    this.fetchPanels()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPanels() {
      this.isLoading = true
      const params = {
        page_size: -1,
        company: this.company.id,
        channel: 'panel',
        enabled: true,
        search: this.searchText || ''
      }
      this.$axios.get('/payment_methods', { params })
        .then(resp => {
          if (resp.data?.results) {
            this.panels = resp.data.results.map(item => ({
              label: item.name,
              value: `${item.panel.id}`,
              raw: item
            }))
          } else {
            this.panels = []
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    apply() {
      this.showMenu = false
      this.selectedItem = this.panels.find(p => p.value === this.checkedItem)
      this.$emit('update:filter', { key: 'panel', value: this.checkedItem })
      this.$emit('update:panelData', this.selectedItem?.raw || null)
    },
    clear() {
      this.clearData()
      this.$emit('update:filter', {})
      this.$emit('update:panelData', null)
    },
    clearSelection() {
      this.checkedItem = null
    },
    clearData() {
      this.checkedItem = null
      this.selectedItem = null
    },
    queryChanged: debounce(function() {
      this.fetchPanels()
    }, 750)
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}

.border-dashed {
  border-style: dashed !important;
}

.menu-header {
  top: 0;
  position: sticky;
  z-index: 1;
}

.hover-bg:hover {
  background-color: #f5f5f5;
}

::v-deep .v-radio {
  .v-input--selection-controls__input {
    margin-right: 0;
  }
}
</style>
